import FormLogo from './src/form-logo.vue'

export default FormLogo
